var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.871 16C14.1935 16 12.9247 15.3227 12.0645 13.9683C11.3333 12.8254 10.9677 11.4286 10.9677 9.77778C10.9677 7.66138 11.5054 5.75662 12.5806 4.06349C13.6989 2.37037 15.3763 1.01588 17.6129 3.07954e-06L18.1935 1.14286C16.8602 1.69313 15.6989 2.56085 14.7097 3.74603C13.7634 4.93122 13.2903 6.13757 13.2903 7.36508C13.2903 7.87302 13.3548 8.31746 13.4839 8.69841C14.172 8.14815 14.9677 7.87302 15.871 7.87302C17.0323 7.87302 18 8.25397 18.7742 9.01587C19.5914 9.73545 20 10.709 20 11.9365C20 13.0794 19.5914 14.0529 18.7742 14.8571C18 15.619 17.0323 16 15.871 16ZM4.90322 16C3.2258 16 1.95699 15.3227 1.09677 13.9682C0.365589 12.8254 -1.99823e-06 11.4286 -1.7096e-06 9.77778C-1.33956e-06 7.66138 0.537634 5.75661 1.6129 4.06349C2.73118 2.37037 4.4086 1.01588 6.64516 1.16188e-06L7.22581 1.14286C5.89247 1.69312 4.73118 2.56085 3.74194 3.74603C2.7957 4.93122 2.32258 6.13757 2.32258 7.36508C2.32258 7.87302 2.3871 8.31746 2.51613 8.69841C3.2043 8.14815 4 7.87302 4.90323 7.87302C6.06452 7.87302 7.03226 8.25397 7.80645 9.01587C8.62365 9.73545 9.03226 10.709 9.03226 11.9365C9.03226 13.0794 8.62365 14.0529 7.80645 14.8571C7.03226 15.619 6.06451 16 4.90322 16Z",
    fill: "url(#paint0_linear_2115_55642)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2115_55642",
    x1: 20,
    y1: 0.00000349691,
    x2: 4.39026,
    y2: 19.5122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D95C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824DB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.05a6436e812ea4af15aacbe127a13be6.svg";
export { ForwardRef as ReactComponent };